'use client';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Drawer,
   DrawerBody,
   DrawerCloseButton,
   DrawerContent,
   DrawerHeader,
   DrawerOverlay,
   Flex,
   Input,
   InputGroup,
   Spinner,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorMode,
   useColorModeValue,
   useDisclosure,
   useOutsideClick,
} from '@chakra-ui/react';
import Select from 'react-select';
import Card from 'components/card/Card';
import { GridItem } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import { Button, Image, Grid } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import json from '../../../../../src/assets/img/nfts/json.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import { getReportStockDetail } from '../../../../redux/actions/reports';
import { columnsReportsSalesDetail } from '../../customDataTable/variables/columnsData';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { useBusinessType, useGlobal, useUser } from '../../../../contexts';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { motion } from 'framer-motion';
import { LuRefreshCcw } from 'react-icons/lu';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { MdCompress, MdExpand } from 'react-icons/md';
import * as XLSX from 'xlsx-js-style';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { deletePurchaseInvoice, getPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { deleteRecord } from 'utils/util';
import SalesDetails from 'components/salesDetails/SalesDetails';
import StockFilter from '../components/StockFilter';
import { IoFilterOutline } from 'react-icons/io5';
import { deleteRecordForSales } from 'utils/util';
import Loader from 'views/admin/default/Loader';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);
const MIN_LOADING_TIME = 300;
const DEBOUNCE_DELAY = 300; // Optimal debounce delay for search

const SerialStock = () => {
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   // Constants
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const [isFilterLoading, setIsFilterLoading] = useState(false);
   const isFirstRenderFilter = useRef(true);

   // Context and Redux
   const { companyList, company } = useGlobal();
   const { userGlobalSettingsData } = useGlobal();
   const { businessTypes } = useBusinessType();
   const dispatch = useDispatch();
   const salesReport = useSelector((state) => state.reports?.stock || []);
   const dbName = company?.dbName;

   const viewData = useSelector((state) => state?.purchaseInvoice?.single);
   const { viewDetail, paginate } = useMemo(() => {
      const data = viewData;
      const pagination = viewData?.pagination;

      return { viewDetail: data, paginate: pagination };
   }, [viewData, viewData?.pagination]);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);

   // Refs
   const abortControllerRef = useRef(null);
   const searchTimeoutRef = useRef(null);
   const wrapperRef = useRef();
   const fromDateInputRef = useRef(null);
   const initialLoadRef = useRef(true);
   const prevDependenciesRef = useRef({});

   // State
   const [companyFilter, setCompanyFilter] = useState([]);
   const [expandedItems, setExpandedItems] = useState({});
   const [searchQuery, setSearchQuery] = useState('');
   const [isLoading, setIsLoading] = useState(false);
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0], // last 7th day
         toDate: today.toISOString().split('T')[0], // today
      };
   });
   const [expanded, setExpanded] = useState(false);

   // Disclosures
   const { isOpen, onOpen, onClose } = useDisclosure();
   const { user } = useUser();
   const admin = user?.isAdmin;
   const rights = user?.userRights?.find((ur) => ur?.companyId === user?.loginhistory?.companyId);
   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;
   const saleInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.saleinvoice
      : null;
   const saleReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.salereturn
      : null;
   const purchaseInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
      : null;
   const purchaseReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
      : null;
   // Constants
   const stockDrop = [
      { value: 0, label: 'Item-wise' }, // Changed from 'id' and 'name' to 'value' and 'label'
      { value: 1, label: 'Serial-Wise' },
   ];
   const [itemWiseSelected, setItemWiseSelected] = useState(stockDrop[0]);

   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   // Initialize expanded state for all items when data loads
   useEffect(() => {
      if (salesReport && Array.isArray(salesReport) && salesReport.length > 0) {
         const initialExpanded = {};

         salesReport.forEach((companyData) => {
            initialExpanded[`company-${companyData.companyId}`] = true;

            if (companyData.data && Array.isArray(companyData.data)) {
               companyData.data.forEach((itemData) => {
                  initialExpanded[`item-${itemData.itemId}-${companyData.companyId}`] = true;
               });
            }
         });

         setExpandedItems(initialExpanded);
      }
   }, [salesReport]);
   useEffect(() => {
      if (isFirstRenderFilter.current) {
         isFirstRenderFilter.current = false;
         return;
      }
      setIsFilterLoading(false);
   }, [salesReport]);

   // Memoized values
   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(() => {
      const currentUserCode = user?.loginhistory?.code;
      const currentCompanyId = user?.loginhistory?.companyId;

      // SHARED COMPANY MODE: When code is present
      if (currentUserCode) {
         // Find the company with matching ID AND matching dbName
         const sharedCompany = companyList.find(
            company => company.id === currentCompanyId && company.dbName === currentUserCode
         );

         if (sharedCompany) {
            return [{
               value: sharedCompany.id,
               label: sharedCompany.name,
               id: sharedCompany.id,
               name: sharedCompany.name,
            }];
         }

         // Fallback: try to find by dbName only
         const companiesWithDbName = companyList.filter(company => company.dbName === currentUserCode);
         if (companiesWithDbName.length > 0) {
            return companiesWithDbName.map(company => ({
               value: company.id,
               label: company.name,
               id: company.id,
               name: company.name,
            }));
         }

         return [];
      }

      // NORMAL MODE: When no code, show companies without dbName
      return companyList
         .filter(company => !company.dbName)
         .map(company => ({
            value: company.id,
            label: company.name,
            id: company.id,
            name: company.name,
         }));
   }, [companyList, user?.loginhistory?.code, user?.loginhistory?.companyId]);

   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [],
      [companyFilter],
   );

   // Initialize default values - ONLY ONCE
   useEffect(() => {
      if (initialLoadRef.current && companyList?.length > 0) {
         const storedCompanyId = localStorage.getItem('companyId');
         if (storedCompanyId) {
            const companyId = parseInt(storedCompanyId);
            const matchingCompany = companyList?.find((comp) => comp.id === companyId);
            if (matchingCompany) {
               setCompanyFilter([matchingCompany.id]);
            }
         }

         // Set default report type based on business type
         const defaultReportType = businessTypes?.businessType === 'MOBILE' ? stockDrop[1] : stockDrop[0];
         setItemWiseSelected(defaultReportType);

         initialLoadRef.current = false;
      }
   }, [companyList, businessTypes]); // Remove stockDrop from dependencies

   // Data fetching with optimized search and dependency tracking
   const fetchData = useCallback(async () => {
      // Validate companyIds - must be an array with at least one valid number
      if (
         !Array.isArray(companyIds) ||
         companyIds.length === 0 ||
         companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0)
      ) {
         console.log('Invalid company IDs, skipping API call');
         return;
      }

      // Check if dependencies have actually changed
      const currentDependencies = {
         companyIds: JSON.stringify(companyIds),
         fromDate: dateRange.fromDate,
         toDate: dateRange.toDate,
         searchQuery: searchQuery.trim(),
      };

      if (JSON.stringify(currentDependencies) === JSON.stringify(prevDependenciesRef.current)) {
         console.log('Dependencies unchanged, skipping API call');
         return;
      }

      // Update previous dependencies
      prevDependenciesRef.current = currentDependencies;

      if (abortControllerRef.current) {
         abortControllerRef.current.abort();
      }

      abortControllerRef.current = new AbortController();
      const startTime = Date.now();
      setIsLoading(true);

      try {
         // Filter out any invalid IDs just to be safe
         const validCompanyIds = companyIds.filter((id) => !isNaN(Number(id)) && Number(id) > 0);

         if (dateRange.fromDate && dateRange.toDate && validCompanyIds.length > 0) {
            await dispatch(
               getReportStockDetail({
                  companyIds: validCompanyIds.join(','),
                  fromDate: dateRange.fromDate,
                  toDate: dateRange.toDate,
                  search: searchQuery.trim(),
               }),
               { signal: abortControllerRef.current.signal },
            );
         }
      } catch (error) {
         if (error.name !== 'AbortError') {
            console.error('Error fetching stock details:', error);
         }
      } finally {
         const elapsedTime = Date.now() - startTime;
         const remainingTime = Math.max(0, MIN_LOADING_TIME - elapsedTime);

         if (remainingTime > 0) {
            await new Promise((resolve) => setTimeout(resolve, remainingTime));
         }

         setIsLoading(false);
         abortControllerRef.current = null;
      }
   }, [dispatch, companyIds, dateRange, searchQuery]);

   // Add this useEffect to automatically fetch data when all required dependencies are available
   useEffect(() => {
      // Validate all parameters before fetching data
      const hasValidCompanyIds =
         Array.isArray(companyIds) &&
         companyIds.length > 0 &&
         !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);
      const hasValidDateRange = dateRange.fromDate && dateRange.toDate;

      if (hasValidCompanyIds && hasValidDateRange) {
         fetchData();
      }
   }, [companyIds, dateRange, fetchData]);

   // Optimized debounced search effect
   useEffect(() => {
      // Skip initial mount to prevent duplicate calls
      if (initialLoadRef.current) {
         return;
      }

      // Clear previous timeout
      if (searchTimeoutRef.current) {
         clearTimeout(searchTimeoutRef.current);
      }

      // Set new timeout
      searchTimeoutRef.current = setTimeout(() => {
         fetchData();
      }, DEBOUNCE_DELAY);

      // Cleanup function
      return () => {
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }
      };
   }, [fetchData]);

   // Handlers
   const handleDateRangeChange = useCallback((dates) => {
      if (!dates || dates.length !== 2) return;
      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));
      setDateRange({ fromDate: from, toDate: to });
   }, []);

   const handleSearchChange = useCallback((e) => {
      const value = e.target.value;
      setSearchQuery(value);
   }, []);

   const handleRefresh = useCallback(() => {
      // Clear any pending search timeouts
      if (searchTimeoutRef.current) {
         clearTimeout(searchTimeoutRef.current);
      }
      // Reset previous dependencies to force a fresh fetch
      prevDependenciesRef.current = {};
      // Fetch data immediately
      fetchData();
   }, [fetchData]);

   const toggleExpand = useCallback((id) => {
      setExpandedItems((prev) => ({
         ...prev,
         [id]: !prev[id],
      }));
   }, []);

   const handleCompanyChange = useCallback((selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions.map((opt) => opt) : []);
   }, []);

   const handleItemWiseChange = useCallback((option) => {
      setItemWiseSelected(option);
   }, []);

   const handleNextPage = () => {
      console.log('Next');
   };
   const handlePrevPage = () => {
      console.log('Prev');
   };

   // Formatting functions
   const formatDateToDDMMYYYY = useCallback((dateString) => {
      if (!dateString) return '-';

      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
   }, []);

   const [columnVisibility, setColumnVisibility] = React.useState(
      columnsReportsSalesDetail.reduce((acc, column) => {
         acc[column.id] = true;
         return acc;
      }, {}),
   );

   // Column visibility management
   useEffect(() => {
      if (itemWiseSelected) {
         if (itemWiseSelected.value === 0) {
            setColumnVisibility({
               itemName: true,
               companyName: true,
               quantity: true,
               totalValue: true,
               status: true,
               serialNo: false,
               date: false,
               daybook: false,
               docno: false,
               account: false,
            });
         } else {
            setColumnVisibility({
               serialNo: true,
               date: true,
               daybook: true,
               docno: true,
               account: true,
               itemRate: true,
               quantity: true,
               status: true,
            });
         }
      }
   }, [itemWiseSelected]);

   const exportToExcel = () => {
      if (!salesReport || salesReport.length === 0) {
         alert('No data to export');
         return;
      }

      try {
         // Create a new workbook
         const wb = XLSX.utils.book_new();

         // Define styles
         const styles = {
            header: {
               fill: { fgColor: { rgb: 'D9E1F2' } }, // Light blue
               font: { bold: true, color: { rgb: '000000' }, sz: 12 },
               alignment: { horizontal: 'center', vertical: 'center' },
               border: {
                  top: { style: 'thin', color: { rgb: '000000' } },
                  bottom: { style: 'thin', color: { rgb: '000000' } },
                  left: { style: 'thin', color: { rgb: '000000' } },
                  right: { style: 'thin', color: { rgb: '000000' } },
               },
            },
            companyHeader: {
               fill: { fgColor: { rgb: 'F1E7E7' } }, // Light pink
               font: { bold: true, sz: 14, color: { rgb: '000000' } },
               alignment: { horizontal: 'left' },
            },
            itemHeader: {
               fill: { fgColor: { rgb: 'F8FAFC' } }, // Very light gray
               font: { bold: true, color: { rgb: '000000' } },
               alignment: { horizontal: 'left' },
            },
            oddRow: {
               fill: { fgColor: { rgb: 'EFF6FF' } }, // Very light blue
               font: { sz: 11 },
               border: {
                  top: { style: 'thin', color: { rgb: 'DDDDDD' } },
                  bottom: { style: 'thin', color: { rgb: 'DDDDDD' } },
               },
            },
            evenRow: {
               fill: { fgColor: { rgb: 'FFFFFF' } }, // White
               font: { sz: 11 },
               border: {
                  top: { style: 'thin', color: { rgb: 'DDDDDD' } },
                  bottom: { style: 'thin', color: { rgb: 'DDDDDD' } },
               },
            },
            totalRow: {
               fill: { fgColor: { rgb: 'F5EEE6' } }, // Light tan
               font: { bold: true, color: { rgb: '000000' } },
               alignment: { horizontal: 'right' },
            },
            currencyFormat: {
               numFmt: '"₹"#,##0.00',
            },
         };

         // Process all data for Excel with styling
         const allData = [];

         // Add report title with styling
         allData.push([{ v: 'Serialized Stock Report', s: { font: { bold: true, sz: 16 } } }]);
         allData.push([
            {
               v: `From ${formatDateToDDMMYYYY(dateRange.fromDate)} to ${formatDateToDDMMYYYY(dateRange.toDate)}`,
               s: { font: { italic: true, sz: 12 } },
            },
         ]);
         allData.push([]); // Empty row

         salesReport.forEach((companyData) => {
            // Add company header with styling
            allData.push([{ v: companyData.companyName, s: styles.companyHeader }]);
            allData.push([]); // Empty row

            if (itemWiseSelected.value === 0) {
               // Item-wise report
               companyData.data.forEach((itemData) => {
                  // Add item header with styling
                  allData.push([{ v: itemData.itemName, s: styles.itemHeader }]);

                  // Add headers with styling
                  const headers = [
                     { v: 'Doc#', s: styles.header },
                     { v: 'Date', s: styles.header },
                     { v: 'Serial No', s: styles.header },
                     { v: 'Day Book', s: styles.header },
                     { v: 'Account', s: styles.header },
                     { v: 'Item Rate (₹)', s: styles.header },
                     { v: 'Pcs', s: styles.header },
                  ];
                  allData.push(headers);

                  // Add serial data with alternating row colors
                  itemData.data.forEach((serialData, index) => {
                     const rowStyle = index % 2 === 0 ? styles.evenRow : styles.oddRow;
                     allData.push([
                        { v: serialData.docno || '', s: rowStyle },
                        { v: formatDateToDDMMYYYY(serialData.transactionAt) || '', s: rowStyle },
                        { v: serialData.serialNo || '', s: rowStyle },
                        { v: serialData.daybook || '', s: rowStyle },
                        { v: serialData.account || '', s: rowStyle },
                        {
                           v: serialData.itemRate ? parseFloat(serialData.itemRate) : 0,
                           t: 'n',
                           s: { ...rowStyle, ...styles.currencyFormat },
                        },
                        {
                           v: serialData.pcs ? parseInt(serialData.pcs) : 0,
                           t: 'n',
                           s: rowStyle,
                        },
                     ]);
                  });

                  // Add total row with styling
                  const totalPcs = itemData.data.reduce((sum, serial) => sum + (parseInt(serial.pcs) || 0), 0);
                  allData.push([
                     { v: 'Total:', s: styles.totalRow },
                     { v: '', s: styles.totalRow },
                     { v: '', s: styles.totalRow },
                     { v: '', s: styles.totalRow },
                     { v: '', s: styles.totalRow },
                     { v: '', s: styles.totalRow },
                     { v: totalPcs, t: 'n', s: styles.totalRow },
                  ]);

                  allData.push([]); // Empty row after each item
               });
            } else {
               // Serial-wise report
               // Add headers with styling
               const headers = [
                  { v: 'Doc#', s: styles.header },
                  { v: 'Date', s: styles.header },
                  { v: 'Serial No', s: styles.header },
                  { v: 'Item Name', s: styles.header },
                  { v: 'Day Book', s: styles.header },
                  { v: 'Account', s: styles.header },
                  { v: 'Item Rate (₹)', s: styles.header },
                  { v: 'Pcs', s: styles.header },
               ];
               allData.push(headers);

               // Add all serial data with alternating row colors
               let rowIndex = 0;
               companyData.data.forEach((itemData) => {
                  itemData.data.forEach((serialData) => {
                     const rowStyle = rowIndex % 2 === 0 ? styles.evenRow : styles.oddRow;
                     allData.push([
                        { v: serialData.docno || '', s: rowStyle },
                        { v: formatDateToDDMMYYYY(serialData.transactionAt) || '', s: rowStyle },
                        { v: serialData.serialNo || '', s: rowStyle },
                        { v: itemData.itemName || '', s: rowStyle },
                        { v: serialData.daybook || '', s: rowStyle },
                        { v: serialData.account || '', s: rowStyle },
                        {
                           v: serialData.itemRate ? parseFloat(serialData.itemRate) : 0,
                           t: 'n',
                           s: { ...rowStyle, ...styles.currencyFormat },
                        },
                        {
                           v: serialData.pcs ? parseInt(serialData.pcs) : 0,
                           t: 'n',
                           s: rowStyle,
                        },
                     ]);
                     rowIndex++;
                  });
               });

               allData.push([]); // Empty row after company
            }
         });

         // Create worksheet
         const ws = XLSX.utils.aoa_to_sheet(allData);

         // Set column widths
         ws['!cols'] = [
            { wch: 12 }, // Doc#
            { wch: 15 }, // Date
            { wch: 15 }, // Serial No
            { wch: 25 }, // Item Name (for serial-wise)
            { wch: 20 }, // Day Book
            { wch: 25 }, // Account
            { wch: 15 }, // Item Rate
            { wch: 8 }, // Pcs
         ];

         // Add merge ranges for headers
         ws['!merges'] = [
            // Merge report title (A1:H1)
            { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } },
            // Merge date range (A2:H2)
            { s: { r: 1, c: 0 }, e: { r: 1, c: 7 } },
         ];

         // Add merge ranges for company and item headers
         let mergeRow = 3; // Start after title and empty rows
         salesReport.forEach((companyData) => {
            // Merge company header (A4:H4)
            ws['!merges'].push({ s: { r: mergeRow, c: 0 }, e: { r: mergeRow, c: 7 } });
            mergeRow += 2; // Skip empty row

            if (itemWiseSelected.value === 0) {
               companyData.data.forEach((itemData) => {
                  // Merge item header
                  ws['!merges'].push({ s: { r: mergeRow, c: 0 }, e: { r: mergeRow, c: 7 } });
                  mergeRow += 1 + itemData.data.length + 2; // Headers + data + total + empty row
               });
            } else {
               mergeRow += 1 + companyData.data.reduce((sum, item) => sum + item.data.length, 0) + 1;
            }
         });

         // Add worksheet to workbook
         XLSX.utils.book_append_sheet(wb, ws, 'Stock Report');

         // Generate safe file name
         const now = new Date();
         const safeFileName = `Stock_Report_${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now
            .getDate()
            .toString()
            .padStart(2, '0')}.xlsx`;

         // Write file
         XLSX.writeFile(wb, safeFileName, { bookType: 'xlsx', type: 'array' });
      } catch (error) {
         console.error('Error exporting to Excel:', error);
         alert('Failed to export Excel file. Please try again.');
      }
   };

   const exportToPDF = useCallback(() => {
      if (!salesReport || salesReport.length === 0) {
         alert('No data to export');
         return;
      }

      try {
         // Create a new PDF document in landscape mode
         const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
         });

         // Define styles
         const styles = {
            title: {
               fontSize: 16,
               fontStyle: 'bold',
               textColor: [0, 0, 0], // Black
               halign: 'center',
            },
            subtitle: {
               fontSize: 12,
               fontStyle: 'bold', // Changed to bold
               textColor: [0, 0, 0], // Changed to black
               halign: 'center',
            },
            companyHeader: {
               fillColor: [241, 231, 231], // Light pink (matches your UI)
               textColor: [0, 0, 0],
               fontStyle: 'bold',
               fontSize: 14,
            },
            itemHeader: {
               fillColor: [248, 250, 252], // Very light gray
               textColor: [0, 0, 0],
               fontStyle: 'bold',
            },
            tableHeader: {
               fillColor: '#B7B7B7', // Light gray
               textColor: [0, 0, 0],
               fontStyle: 'bold',
            },
            oddRow: {
               fillColor: [255, 255, 255], // White
               textColor: [0, 0, 0],
            },
            evenRow: {
               fillColor: [239, 246, 255], // Very light blue
               textColor: [0, 0, 0],
            },
            totalRow: {
               fillColor: [245, 238, 230], // Light tan
               textColor: [0, 0, 0],
               fontStyle: 'bold',
            },
         };

         // Add title and date range
         doc.setFontSize(styles.title.fontSize);
         doc.setFont('helvetica', styles.title.fontStyle);
         doc.setTextColor(...styles.title.textColor);
         doc.text('Serialized Stock Report', doc.internal.pageSize.width / 2, 15, {
            align: styles.title.halign,
         });

         doc.setFontSize(styles.subtitle.fontSize);
         doc.setFont('helvetica', styles.subtitle.fontStyle);
         doc.setTextColor(...styles.subtitle.textColor);
         doc.text(
            `From ${formatDateToDDMMYYYY(dateRange.fromDate)} to ${formatDateToDDMMYYYY(dateRange.toDate)}`,
            doc.internal.pageSize.width / 2,
            22,
            { align: styles.subtitle.halign },
         );

         let startY = 30; // Starting Y position after title and subtitle

         // Process each company's data
         salesReport.forEach((companyData, companyIndex) => {
            // Add company header
            doc.setFontSize(styles.companyHeader.fontSize);
            doc.setFont('helvetica', styles.companyHeader.fontStyle);
            doc.setTextColor(...styles.companyHeader.textColor);
            doc.text(companyData.companyName, 14, startY);

            startY += 10; // Move down after company header

            if (itemWiseSelected.value === 0) {
               // ITEM-WISE FORMAT

               // Define table columns (only once for all items)
               const columns = [
                  { header: 'Doc#', dataKey: 'docno' },
                  { header: 'Date', dataKey: 'date' },
                  { header: 'Serial No', dataKey: 'serialNo' },
                  { header: 'Day Book', dataKey: 'daybook' },
                  { header: 'Account', dataKey: 'account' },
                  { header: 'Item Rate', dataKey: 'itemRate' },
                  { header: 'Pcs', dataKey: 'pcs' },
               ];

               // Prepare all table data for this company
               const allTableData = [];

               // Process each item
               companyData.data.forEach((itemData, itemIndex) => {
                  // Calculate total for this item
                  const totalPcs = itemData.data.reduce((sum, serial) => sum + (parseInt(serial.pcs) || 0), 0);

                  // Add item header row with total in Pcs column
                  allTableData.push({
                     docno: itemData.itemName,
                     date: '',
                     serialNo: '',
                     daybook: '',
                     account: '',
                     itemRate: '',
                     pcs: totalPcs.toString(),
                     isItemHeader: true,
                  });

                  // Add item data rows
                  itemData.data.forEach((serialData) => {
                     allTableData.push({
                        docno: serialData.docno || '-',
                        date: formatDateToDDMMYYYY(serialData.transactionAt),
                        serialNo: serialData.serialNo || '-',
                        daybook: serialData.daybook || '-',
                        account: serialData.account || '-',
                        itemRate: serialData.itemRate || '0',
                        pcs: serialData.pcs || '0',
                     });
                  });
               });

               // Add single table with all data
               doc.autoTable({
                  columns,
                  body: allTableData,
                  startY,
                  margin: { left: 14 },
                  headStyles: {
                     fillColor: styles.tableHeader.fillColor,
                     textColor: styles.tableHeader.textColor,
                     fontStyle: styles.tableHeader.fontStyle,
                     fontSize: 9,
                  },
                  alternateRowStyles: {
                     fillColor: styles.evenRow.fillColor,
                  },
                  styles: {
                     cellPadding: 2,
                     fontSize: 7,
                     textColor: [0, 0, 0],
                  },
                  columnStyles: {
                     itemRate: { halign: 'right' },
                     pcs: { halign: 'right' },
                  },
                  didParseCell: function (data) {
                     const rowData = allTableData[data.row.index];

                     // Style item header rows
                     if (rowData && rowData.isItemHeader) {
                        data.cell.styles.fillColor = styles.itemHeader.fillColor;
                        data.cell.styles.fontStyle = 'bold';
                        data.cell.styles.textColor = styles.itemHeader.textColor;
                        data.cell.styles.fontSize = 10;
                     }
                  },
               });

               // Update position after table
               startY = doc.lastAutoTable.finalY + 10;
            } else {
               // SERIAL-WISE FORMAT

               // Define table columns
               const columns = [
                  { header: 'Doc#', dataKey: 'docno' },
                  { header: 'Date', dataKey: 'date' },
                  { header: 'Serial No', dataKey: 'serialNo' },
                  { header: 'Item Name', dataKey: 'itemName' },
                  { header: 'Day Book', dataKey: 'daybook' },
                  { header: 'Account', dataKey: 'account' },
                  { header: 'Item Rate', dataKey: 'itemRate' },
                  { header: 'Pcs', dataKey: 'pcs' },
               ];

               // Prepare table data
               const tableData = companyData.data.flatMap((itemData) =>
                  itemData.data.map((serialData) => ({
                     docno: serialData.docno || '-',
                     date: formatDateToDDMMYYYY(serialData.transactionAt),
                     serialNo: serialData.serialNo || '-',
                     itemName: itemData.itemName || '-',
                     daybook: serialData.daybook || '-',
                     account: serialData.account || '-',
                     itemRate: serialData.itemRate || '0',
                     pcs: serialData.pcs || '0',
                  })),
               );

               // Add table to PDF
               doc.autoTable({
                  columns,
                  body: tableData,
                  startY,
                  margin: { left: 14 },
                  headStyles: {
                     fillColor: styles.tableHeader.fillColor,
                     textColor: styles.tableHeader.textColor,
                     fontStyle: styles.tableHeader.fontStyle,
                     fontSize: 9, // Slightly larger for headers
                  },
                  alternateRowStyles: {
                     fillColor: styles.evenRow.fillColor,
                  },
                  styles: {
                     cellPadding: 2,
                     fontSize: 8,
                     textColor: [0, 0, 0], // Force black text for all table cells
                  },
                  columnStyles: {
                     itemRate: { halign: 'right' },
                     pcs: { halign: 'right' },
                  },
               });

               // Update position after table
               startY = doc.lastAutoTable.finalY + 10;
            }

            // Add a new page for each company except the last one
            if (companyIndex < salesReport.length - 1) {
               doc.addPage('landscape');
               startY = 20; // Reset Y position for new page
            }
         });

         // Generate safe file name
         const now = new Date();
         const safeFileName = `Serial_Stock_Report_${now.getFullYear()}${(now.getMonth() + 1)
            .toString()
            .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}.pdf`;

         // Save the PDF
         doc.save(safeFileName);
      } catch (error) {
         console.error('Error exporting to PDF:', error);
         alert('Failed to export PDF file. Please try again.');
      }
   }, [salesReport, itemWiseSelected, dateRange, formatDateToDDMMYYYY]);

   const storedCompanyId = localStorage.getItem('companyId');

   const calculateGrandTotals = useCallback(() => {
      if (!salesReport || salesReport.length === 0 || companyFilter.length <= 1) {
         return null;
      }

      const grandTotals = {
         totalPcs: 0,
         totalAmount: 0,
         totalItemRate: 0,
         totalSerialCount: 0,
         companyCount: companyFilter.length,
      };

      salesReport.forEach((companyData) => {
         if (!companyData.data) return;

         companyData.data.forEach((item) => {
            if (item.data && Array.isArray(item.data)) {
               grandTotals.totalSerialCount += item.data.length;

               item.data.forEach((serial) => {
                  const pcs = parseFloat(serial.pcs) || 0;
                  const itemRate = parseFloat(serial.itemRate) || 0;

                  grandTotals.totalPcs += pcs;
                  grandTotals.totalItemRate += itemRate;
                  grandTotals.totalAmount += pcs * itemRate;
               });
            }
         });
      });

      return grandTotals;
   }, [salesReport, companyFilter]);

   const GrandTotalHeader = React.memo(({ grandTotals }) => {
      const bgColor = useColorModeValue('#f0f0f0', '#2d3748');
      const textColor = useColorModeValue('#000000', '#ffffff');
      const borderColor = useColorModeValue('#ccc', '#4a5568');

      if (!grandTotals) return null;

      return (
         <Box
            mb={4}
            p={3}
            bg={bgColor}
            borderRadius="md"
            border="1px solid"
            borderColor={borderColor}
            w={'100%'}
            color={textColor}>

            <Flex flexWrap="wrap" justifyContent="space-between" alignItems="center" gap={4}>
               <div>
                  <Text fontWeight="bold" fontSize="md">
                     GRAND TOTAL ({grandTotals.companyCount} {grandTotals.companyCount === 1 ? 'Company' : 'Companies'}):
                  </Text>
               </div>
               <div style={{ textAlign: 'right', display: "flex" }}>
                  <Text fontSize="sm">
                     <strong>Total Pcs:</strong> {grandTotals.totalPcs.toLocaleString('en-IN')}
                  </Text>
               </div>
            </Flex>
         </Box>
      );
   });

   const deletePurchaseReturn = () => {
      deleteRecordForSales(
         viewDetail?.id,
         viewDetail?.daybookId,
         viewDetail?.accountId,
         deletePurchaseInvoice,
         dispatch,
         storedCompanyId,
         userGlobalSettingsData,
      );
      setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => {
      setIsOpenPurchaseReturnSingleView();
   };

   const formatCurrencyWithSmallDecimal = useCallback((value, showRupeeSymbol = false) => {
      if (value === null || value === undefined || value === '') return showRupeeSymbol ? '₹-' : '-';
      const numValue = Number(value);
      if (isNaN(numValue)) return showRupeeSymbol ? '₹' + String(value) : String(value);

      const formatted = Math.abs(numValue).toLocaleString('en-IN', {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
      });

      // Split into integer and decimal parts for smaller decimal font
      const parts = formatted.split('.');

      if (parts.length === 2) {
         const formattedElement = (
            <>
               {parts[0]}.<span style={{ fontSize: '10px' }}>{parts[1]}</span>
            </>
         );

         return showRupeeSymbol ? <>₹{formattedElement}</> : formattedElement;
      }

      return showRupeeSymbol ? <>₹{formatted}</> : formatted;
   }, []);

   // फिर renderItemWiseData function को update करें:
   const renderItemWiseData = useCallback(
      (companyData) => {
         const handledata = async (data) => {
            const storedCompanyId = localStorage.getItem('companyId');
            const companyId = parseInt(storedCompanyId);
            if (data.companyId === companyId && (admin || rights?.purchaseinvoice?.view)) {
               await dispatch(getPurchaseInvoice(data.purchaseHeaderId));
               setIsOpenPurchaseReturnSingleView(true);
            }
         };

         return companyData.data.map((itemData, itemIndex) => (
            <React.Fragment key={`item-${itemData.itemId || itemIndex}`}>
               <Tr
                  cursor="pointer"
                  onClick={() => toggleExpand(`item-${itemData.itemId}-${companyData.companyId}`)}
                  className={`${isDark
                     ? 'bg-gradient-to-r from-slate-800 to-slate-900 border-l-4 border-cyan-400'
                     : 'bg-gradient-to-r from-cyan-50 to-blue-50 border-l-4 border-cyan-500'
                     } transition-all duration-300 hover:shadow-md`}>
                  <Td colSpan={8} p={2}>
                     <Flex justifyContent="space-between" alignItems="center" pl={2}>
                        <Text
                           fontWeight="bold"
                           className={`${isDark ? 'text-cyan-200' : 'text-cyan-900'} text-base tracking-wide`}>
                           {itemData.itemName}
                        </Text>
                        <Box className={isDark ? 'text-cyan-300' : 'text-cyan-600'}>
                           {expandedItems[`item-${itemData.itemId}-${companyData.companyId}`] ? (
                              <ChevronUpIcon />
                           ) : (
                              <ChevronDownIcon />
                           )}
                        </Box>
                     </Flex>
                  </Td>
               </Tr>

               {expandedItems[`item-${itemData.itemId}-${companyData.companyId}`] && (
                  <>
                     <Tr
                        className={`${isDark
                           ? 'bg-slate-900 border-b-2 border-slate-700'
                           : 'bg-slate-100 border-b-2 border-slate-300'
                           }`}>
                        <Td
                           p={2}
                           fontSize="12px"
                           fontWeight="bold"
                           className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                           Serial No
                        </Td>
                        <Td
                           p={2}
                           fontSize="12px"
                           fontWeight="bold"
                           className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                           Date
                        </Td>
                        <Td
                           p={2}
                           fontSize="12px"
                           fontWeight="bold"
                           className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                           Day Book
                        </Td>
                        <Td
                           p={2}
                           fontSize="12px"
                           fontWeight="bold"
                           className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                           Doc#
                        </Td>
                        <Td
                           p={2}
                           fontSize="12px"
                           fontWeight="bold"
                           className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                           Account
                        </Td>
                        <Td
                           p={2}
                           fontSize="12px"
                           fontWeight="bold"
                           className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                           Item Rate
                        </Td>
                        <Td
                           p={2}
                           fontSize="12px"
                           fontWeight="bold"
                           className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                           Pcs
                        </Td>
                     </Tr>

                     {itemData.data.map((serialData, serialIndex) => {
                        const isOddRow = serialIndex % 2 !== 0;
                        return (
                           <Tr
                              key={`serial-${serialData.id || serialIndex}`}
                              cursor="pointer"
                              onClick={() => handledata(serialData)}
                              className={`transition-all duration-200 ${isOddRow
                                 ? isDark
                                    ? 'bg-slate-800 bg-opacity-50 hover:bg-slate-700'
                                    : 'bg-slate-50 hover:bg-slate-100'
                                 : isDark
                                    ? 'bg-transparent hover:bg-slate-800 hover:bg-opacity-30'
                                    : 'bg-white hover:bg-slate-50'
                                 }`}>
                              <Td py={2} fontSize="12px" color={textColor} className="font-medium">
                                 {serialData.serialNo}
                              </Td>
                              <Td py={2} fontSize="12px" color={textColor} className="font-medium">
                                 {formatDateToDDMMYYYY(serialData.transactionAt)}
                              </Td>
                              <Td py={2} fontSize="12px" color={textColor} className="font-medium">
                                 {serialData.daybook}
                              </Td>
                              <Td py={2} fontSize="12px" color={textColor} className="font-medium">
                                 {serialData.docno}
                              </Td>
                              <Td py={2} fontSize="12px" color={textColor} className="font-medium">
                                 {serialData.account}
                              </Td>
                              <Td py={2} fontSize="12px" color={textColor} className="font-medium" isNumeric>
                                 {formatCurrencyWithSmallDecimal(serialData.itemRate)}
                              </Td>
                              <Td py={2} fontSize="12px" color={textColor} className="font-medium" isNumeric>
                                 {serialData.pcs}
                              </Td>
                           </Tr>
                        );
                     })}

                     <Tr
                        className={`${isDark
                           ? 'bg-gradient-to-r from-emerald-900 to-teal-900 border-t-2 border-emerald-700'
                           : 'bg-gradient-to-r from-emerald-50 to-teal-50 border-t-2 border-emerald-300'
                           }`}>
                        <Td
                           colSpan={6}
                           textAlign="right"
                           fontSize="14px"
                           fontWeight="bold"
                           className={`${isDark ? 'text-emerald-200' : 'text-emerald-900'} py-3`}>
                           Total:
                        </Td>
                        <Td
                           fontSize="14px"
                           fontWeight="bold"
                           className={`${isDark ? 'text-emerald-100' : 'text-emerald-900'} py-3`}
                           isNumeric>
                           {itemData.data.reduce((sum, serial) => sum + parseInt(serial.pcs || 0), 0)}
                        </Td>
                     </Tr>
                  </>
               )}
            </React.Fragment>
         ));
      },
      [expandedItems, formatDateToDDMMYYYY, textColor, toggleExpand, isDark, formatCurrencyWithSmallDecimal],
   );

   // renderSerialWiseData function को update करें:
   const renderSerialWiseData = useCallback(
      (companyData) => {
         const handledata = async (data) => {
            const companyId = parseInt(storedCompanyId);
            if (data.companyId === companyId && (admin || rights?.purchaseinvoice?.view)) {
               await dispatch(getPurchaseInvoice(data.purchaseHeaderId));
               setIsOpenPurchaseReturnSingleView(true);
            }
         };
         return (
            <>
               <Tr
                  className={`${isDark ? 'bg-slate-900 border-b-2 border-slate-700' : 'bg-slate-100 border-b-2 border-slate-300'
                     }`}>
                  <Td py={2} fontSize="12px" fontWeight="bold" className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                     Serial No
                  </Td>
                  <Td py={2} fontSize="12px" fontWeight="bold" className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                     Item Name
                  </Td>
                  <Td py={2} fontSize="12px" fontWeight="bold" className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                     Date
                  </Td>
                  <Td py={2} fontSize="12px" fontWeight="bold" className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                     Day Book
                  </Td>
                  <Td py={2} fontSize="12px" fontWeight="bold" className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                     Doc#
                  </Td>
                  <Td py={2} fontSize="12px" fontWeight="bold" className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                     Account
                  </Td>
                  <Td py={2} fontSize="12px" fontWeight="bold" className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                     Item Rate
                  </Td>
                  <Td py={2} fontSize="12px" fontWeight="bold" className={isDark ? 'text-slate-300' : 'text-slate-700'}>
                     Pcs
                  </Td>
               </Tr>

               {companyData.data.flatMap((itemData, itemIndex) =>
                  itemData.data.map((serialData, serialIndex) => {
                     const globalIndex = itemIndex * itemData.data.length + serialIndex;
                     const isOddRow = globalIndex % 2 !== 0;

                     return (
                        <Tr
                           key={`flat-serial-${serialData.id || globalIndex}`}
                           cursor="pointer"
                           onClick={() => handledata(serialData)}
                           className={`transition-all duration-200 ${isOddRow
                              ? isDark
                                 ? 'bg-slate-800 bg-opacity-50 hover:bg-slate-700'
                                 : 'bg-slate-50 hover:bg-slate-100'
                              : isDark
                                 ? 'bg-transparent hover:bg-slate-800 hover:bg-opacity-30'
                                 : 'bg-white hover:bg-slate-50'
                              }`}>
                           <Td py={2} fontSize="12px" color={textColor} className="font-medium">
                              {serialData.serialNo}
                           </Td>
                           <Td py={2} fontSize="12px" color={textColor} className="font-medium">
                              {itemData.itemName}
                           </Td>
                           <Td py={2} fontSize="12px" color={textColor} className="font-medium">
                              {formatDateToDDMMYYYY(serialData.transactionAt)}
                           </Td>
                           <Td py={2} fontSize="12px" color={textColor} className="font-medium">
                              {serialData.daybook}
                           </Td>
                           <Td py={2} fontSize="12px" color={textColor} className="font-medium">
                              {serialData.docno}
                           </Td>
                           <Td py={2} fontSize="12px" color={textColor} className="font-medium">
                              {serialData.account}
                           </Td>
                           <Td py={2} fontSize="12px" color={textColor} className="font-medium" isNumeric>
                              {formatCurrencyWithSmallDecimal(serialData.itemRate)}
                           </Td>
                           <Td py={2} fontSize="12px" color={textColor} className="font-medium" isNumeric>
                              {serialData.pcs}
                           </Td>
                        </Tr>
                     );
                  }),
               )}
            </>
         );
      },
      [formatDateToDDMMYYYY, textColor, isDark, formatCurrencyWithSmallDecimal],
   );

   const renderStockReport = useCallback(() => {
      if (isLoading) {
         return (
            <Tr>
               <Td colSpan={8} textAlign="center" py="100px">
                  <Loader />
               </Td>
            </Tr>
         );
      }

      if (!salesReport || !Array.isArray(salesReport) || salesReport.length === 0) {
         return (
            <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
               <Td colSpan={8} justifyContent="center" alignItems="center" width="100%">
                  <Grid justifyContent="center" alignItems="center" gap={9}>
                     <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                     <GridItem justifySelf="center">
                        <label className={isDark ? 'text-slate-400' : 'text-slate-600'}>No stock data found</label>
                     </GridItem>
                  </Grid>
               </Td>
            </Tr>
         );
      }

      const isItemWise = itemWiseSelected && itemWiseSelected.value === 0;

      // Calculate grand totals
      const grandTotals = calculateGrandTotals();

      return (
         <>
            {/* Grand Total Header - Only show when multiple companies selected */}
            {grandTotals && (
               <Box mb={4}>
                  <GrandTotalHeader grandTotals={grandTotals} />
               </Box>
            )}

            {salesReport.map((companyData, companyIndex) => (
               <React.Fragment key={`company-${companyData.companyId || companyIndex}`}>
                  <Tr
                     cursor="pointer"
                     justifyContent="space-between"
                     alignItems="center"
                     width="100%"
                     height="100%"
                     onClick={() => toggleExpand(`company-${companyData.companyId}`)}
                     className={`${isDark
                        ? 'bg-gradient-to-r from-sky-900 via-purple-900 to-sky-900 border-l-4 border-sky-400'
                        : 'bg-gradient-to-r from-blue-50 via-sky-50 to-blue-50 border-l-4 border-sky-500'
                        } transition-all duration-300 hover:shadow-lg`}>
                     <Td colSpan={isItemWise ? 7 : 8} p={2}>
                        <Flex justifyContent="space-between" width="100%" height="100%" alignItems="center">
                           <Text
                              fontWeight="bold"
                              fontSize="lg"
                              className={`${isDark ? 'text-sky-200' : 'text-sky-900'} tracking-wide`}>
                              {companyData.companyName}
                           </Text>
                           <Box className={isDark ? 'text-sky-300' : 'text-sky-600'}>
                              {expandedItems[`company-${companyData.companyId}`] ? <ChevronUpIcon /> : <ChevronDownIcon />}
                           </Box>
                        </Flex>
                     </Td>
                  </Tr>

                  {expandedItems[`company-${companyData.companyId}`] &&
                     companyData.data &&
                     Array.isArray(companyData.data) &&
                     (isItemWise ? renderItemWiseData(companyData) : renderSerialWiseData(companyData))}
               </React.Fragment>
            ))}
         </>
      );
   }, [
      isLoading,
      salesReport,
      itemWiseSelected,
      expandedItems,
      toggleExpand,
      renderItemWiseData,
      renderSerialWiseData,
      isDark,
      calculateGrandTotals,
   ]);

   return (
      <>
         <Flex pr="25px" mb="8px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Serialized Stock
               </Text>
            </Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex className="flex flex-wrap gap-2" alignItems="center" justifyContent={{ base: 'end' }}>
               <Flex flex="0" gap={0} mr={4} display={{ base: 'none', xl: 'flex' }}>
                  <Box
                     my={2}
                     width="300px"
                     fontSize={'13px'}
                     mt={5}
                     fontWeight={500}
                     display={{ base: 'none', xl: 'block' }}>
                     <GridItem className="seperator-width">
                        {renderDynamicDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: companyFilter,
                              onChange: handleCompanyChange,
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           undefined,
                           true,
                        )}
                     </GridItem>
                  </Box>
               </Flex>
               <Flex flex="" gap={2} mr={3} display={{ base: 'none', xl: 'flex' }}>
                  <Box my={2} width="170px" fontSize="13px" fontWeight={500}>
                     <label>Report-Type</label>
                     <Select
                        placeholder="Select Report-Type"
                        name="Report-Type"
                        options={stockDrop}
                        value={itemWiseSelected}
                        onChange={handleItemWiseChange}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
               </Flex>
               <Flex flex="2" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
               </Flex>
               <Flex flex="1"></Flex>
               <Flex>
                  <Box flex="1" mr={3}>
                     <MotionFlex
                        ref={wrapperRef}
                        align="center"
                        bg={bg}
                        borderRadius="full"
                        cursor="pointer"
                        px={expanded ? 3 : 0}
                        w={expanded ? '250px' : '40px'}
                        h="40px"
                        transition="all 0.3s ease"
                        onClick={() => setExpanded(true)}>
                        <MotionSearchIcon
                           color={icon}
                           animate={{ rotate: expanded ? 0 : 90 }}
                           transition={{ duration: 0.3 }}
                           style={{
                              marginRight: expanded ? '8px' : '10px',
                              marginLeft: expanded ? '0' : '10px',
                           }}
                        />
                        {expanded && (
                           <InputGroup width="200px">
                              <Input
                                 placeholder="Search..."
                                 value={searchQuery}
                                 onChange={handleSearchChange}
                                 color={icon}
                                 variant="unstyled"
                                 _focus={{ outline: 'none' }}
                              />
                           </InputGroup>
                        )}
                     </MotionFlex>
                  </Box>
                  <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2}>
                     <LuRefreshCcw size={20} mr={2} />
                  </Button>

                  <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                     <IoFilterOutline size={22} />
                  </Button>

                  <Popover>
                     <PopoverTrigger>
                        <img src={Download} alt="Download" width="30" style={{ cursor: 'pointer' }} />
                     </PopoverTrigger>
                     <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                        <PopoverBody p="3">
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={exportToExcel}
                              justifyContent="space-between"
                              mb={3}>
                              <img src={xls} alt="Download XLS" width="30px"></img>
                              Download Excel
                           </Button>
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={exportToPDF}
                              justifyContent="space-between">
                              <img src={xls} alt="Download pdf" width="30px" mr></img>
                              Download Pdf
                           </Button>
                        </PopoverBody>
                     </PopoverContent>
                  </Popover>
               </Flex>
               <Box ml="">
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                        <Box my={4} width="100%" fontSize="13px" fontWeight={500}>
                           <label>Report Type</label>
                           <Select
                              placeholder="Select Report-Type"
                              name="Report-Type"
                              options={stockDrop}
                              value={itemWiseSelected}
                              onChange={handleItemWiseChange}
                              className="basic-multi-select"
                              classNamePrefix="select"
                           />
                        </Box>
                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                              onChange={handleDateRangeChange}
                              defaultPeriod="last7Days"
                              style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>
                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '75vh', md: '75vh', xl: '75vh' }}
                  maxH={{ base: '75vh', md: '75vh', xl: '75vh' }}>
                  {isFilterLoading && (
                     <Box
                        position="fixed"
                        top={0} left={0} right={0} bottom={0}
                        zIndex={9999}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg={isDark ? 'rgba(10,20,50,0.60)' : 'rgba(255,255,255,0.60)'}
                        backdropFilter="blur(3px)"
                     >
                        <Flex direction="column" align="center" gap={3}>
                           <Loader />
                        </Flex>
                     </Box>
                  )}
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                     <Tbody>{renderStockReport()}</Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>

         <StockFilter
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={dateRange.fromDate}
            toDate={dateRange.toDate}
            // stockStatus={itemWiseSelected?.value}
            entityType="stock"
            onApply={() => setIsFilterLoading(true)}
         />

         <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView}
            onClose={handleSalesDetailsClose}
            singleEntityRights={saleInvoiceRight || saleReturnRight || purchaseInvoiceRight || purchaseReturnRight}
            title={'Purchase Invoice'}
            entityType={'purchaseinvoice'}
            singleEntity={viewDetail}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            setIsEditFormOpen={setIsEditFormOpen}
            setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen}
            // paginate={paginateData}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            billTerms={viewDetail?.purchasereturnbillteams}
            onDelete={deletePurchaseReturn}
            handleSerchClose={() => console.log('')}
         />
      </>
   );
};

export default SerialStock;
